<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/preface#preface">P<span class="small">REFACE</span></a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch01#ch01"><strong>1.<br/>From Homer to Shakespeare:<br/>The Rise of Service Translation<br/>in the Late Eighteenth Century</strong></a></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>2.<br/>The Translation as a Doppelgänger:<br/><em>Amphitryon</em> by Molière and Kleist</strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>3.<br/>Hölderlin as Translator:<br/>The Perils of Interpretation</strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>4.<br/>The Paradox of the Translator:<br/>Goethe and Diderot</strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/coda#coda" title="Link target outside of Sample"><strong>Coda:<br/>From the Nineteenth to the Twenty-First Century</strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/abbreviations#abbreviations" title="Link target outside of Sample"><strong>A<span class="small">BBREVIATIONS</span></strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><strong>N<span class="small">OTES</span></strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/bibliography#bibliography" title="Link target outside of Sample"><strong>B<span class="small">IBLIOGRAPHY</span></strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><strong>I<span class="small">NDEX</span></strong></span></p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?19dac584